import { bagCount, bagLabel, parseBag, type BagItem } from "./shop-bag-items";

// The bag lives in this browser only. Nothing here reaches the server until checkout.

const storageKey = (creatorId: string) => `drate-shop:${creatorId}`;
// Sent on `document` whenever this tab changes a bag, so the header count follows.
const changed = "drate:bag";

export function readBag(creatorId: string): BagItem[] {
  try {
    return parseBag(localStorage.getItem(storageKey(creatorId)));
  } catch {
    return [];
  }
}

/** Saves the bag. Throws when the browser refuses storage, so the caller can say so. */
export function writeBag(creatorId: string, bag: readonly BagItem[]) {
  localStorage.setItem(storageKey(creatorId), JSON.stringify(bag));
  document.dispatchEvent(new Event(changed));
}

function showCounts() {
  for (const link of document.querySelectorAll<HTMLElement>("[data-shop-bag]")) {
    const count = bagCount(readBag(link.dataset.shopBag!));
    const badge = link.querySelector<HTMLElement>("[data-shop-bag-count]");
    const text = count > 99 ? "99+" : String(count);
    if (badge && badge.textContent !== text) {
      badge.textContent = text;
      // A new count plays its entrance. The header fills in its own count before first
      // paint, so this only runs for a change made after the page loaded.
      badge.removeAttribute("data-changed");
      void badge.offsetWidth;
      if (count) badge.setAttribute("data-changed", "");
    }
    if (badge) badge.hidden = !count;
    // On a phone the header shows the bag only once it holds something.
    link.toggleAttribute("data-empty", !count);
    link.setAttribute("aria-label", bagLabel(count));
  }
}

let watching = false;

// Keeps every bag link on the page showing the saved count: after each navigation,
// when this tab changes the bag, and when another tab does.
export function watchBagCount() {
  if (!watching) {
    watching = true;
    document.addEventListener("astro:page-load", showCounts);
    document.addEventListener(changed, showCounts);
    window.addEventListener("storage", (event) => {
      if (!event.key || event.key.startsWith("drate-shop:")) showCounts();
    });
    window.addEventListener("pageshow", showCounts);
  }
  showCounts();
}
